import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import en from '../i18n/en';
import ja from '../i18n/ja';
import axios from 'axios';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [lang, setLang] = useState(localStorage.getItem('lang') || 'ja');
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token') || null);
  const [loading, setLoading] = useState(true);

  const t = lang === 'ja' ? ja : en;

  const toggleLang = () => {
    const next = lang === 'ja' ? 'en' : 'ja';
    setLang(next);
    localStorage.setItem('lang', next);
  };

  const login = (userData, authToken) => {
    setUser(userData);
    setToken(authToken);
    localStorage.setItem('token', authToken);
    localStorage.setItem('user', JSON.stringify(userData));
    if (userData.preferred_lang) {
      setLang(userData.preferred_lang);
      localStorage.setItem('lang', userData.preferred_lang);
    }
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  };

  const api = useCallback((method, url, data = null) => {
    return axios({
      method,
      url: `/api${url}`,
      data,
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
  }, [token]);

  useEffect(() => {
    const stored = localStorage.getItem('user');
    if (stored && token) {
      try { setUser(JSON.parse(stored)); } catch {}
    }
    setLoading(false);
  }, [token]);

  return (
    <AppContext.Provider value={{ lang, t, toggleLang, user, token, login, logout, api, loading }}>
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => useContext(AppContext);
